import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import {
  EntrancePlantDetailDTO,
  ApartmentLabelDTO,
  ApartmentDTO,
  BuildingImportDto,
  LabelType,
} from '../../../../../../client-generator/generated-clients/plants';
export interface multiLabelApartment {
  BuildingName?: string;
  ApartmentName?: string;
  validLines?: label[];
}
export interface singleLabelApartment {
  BuildingName?: string;
  ApartmentName?: string;
  label: label;
}
interface label {
  Line1?: string;
  Line2?: string;
  Type?: LabelType;
  Info?: string;
}
interface recap {
  ApartmentName: string;
  BuildingName: string;
  OldLabel: label[];
  NewLabel: label[];
  isNew: boolean;
}
@Options({
  name: 'DialogImportFile',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    importedData: {
      type: Array as PropType<singleLabelApartment[]>,
      required: false,
    },
    isCallingMode: {
      type: Boolean,
      required: false,
    },
    isCreationMode: {
      type: Boolean,
      required: false,
    },
    EntrancePlantDetail: {
      type: EntrancePlantDetailDTO,
      required: true,
    },
  },
  watch: {
    isVisible(newValue) {
      if (newValue) return;
      this.dialogStep = 1;
      this.flattenedList = [];
      this.selectedList = [];
    },
    selectedList(newVal) {
      let tmp: { [key: string]: number } = {};
      newVal.forEach((item: singleLabelApartment) => {
        tmp[`${item.ApartmentName}|${item.BuildingName}`] = 0;
      });

      this.selectedCount = Object.keys(tmp).length;
    },
    importedData(newValue) {
      this.flattenedList = [];
      if (newValue && Array.isArray(newValue)) {
        newValue = this.limitCharsLabel(newValue);
        if (!this.isCreationMode) {
          this.flattenedList = this.cleanSingleLabelAppartment(newValue);
        } else {
          this.flattenedList = newValue;
        }
      }
    },
  },

  emits: ['hide-dialog', 'save-label', 'update-plant', 'grouped'],
})
export default class DialogImportFile extends Vue {
  isVisible!: boolean;
  isCreationMode!: boolean;
  isCallingMode!: boolean;
  flattenedList: singleLabelApartment[] = [];
  selectedList: singleLabelApartment[] = [];
  EntrancePlantDetail: EntrancePlantDetailDTO = {} as EntrancePlantDetailDTO;

  shouldShowWarningStep2 = false;
  shouldShowWarningStep4 = false;
  dialogStep = 1;
  recap: recap[] = [];
  overwrited: recap[] = [];
  selectedCount = 0;
  selectedGrouped: multiLabelApartment[] = [];

  get dialogTitle() {
    switch (this.dialogStep) {
      case 1:
        return this.$t('labelToImport');
      case 3:
        return this.$t('assignApartments');

      default:
        return '';
    }
  }

  get subtitle() {
    switch (this.dialogStep) {
      case 1:
        return this.$t('selectLabelsUpper');
      case 3:
        return this.$t('choseApartmentForLabelsUpper');
      default:
        return '';
    }
  }
  get disabledFlattenedList() {
    return this.flattenedList.map((data: singleLabelApartment) => ({
      ...data,
      isDisabled: this.isDisabled(data),
    }));
  }

  get disableSaveButton() {
    if (this.dialogStep === 1) {
      return this.selectedCount <= 0;
    } else if (this.dialogStep === 3) {
      return this.selectedGrouped.some(
        (item, i) =>
          !item.BuildingName ||
          !item.ApartmentName ||
          !this.isAvailable(item.BuildingName!, item.ApartmentName!, i)
      );
    }
    return false;
  }

  get apartmentsAlreadyCreatedCount() {
    let apartmentsAlreadyCreatedCount = 0;
    this.EntrancePlantDetail.buildings?.forEach((building) => {
      if (building.apartments) {
        apartmentsAlreadyCreatedCount += building.apartments.length;
      }
    });
    return apartmentsAlreadyCreatedCount;
  }

  cleanSingleLabelAppartment(data: singleLabelApartment[]) {
    return data.map((item) => {
      let building = item.BuildingName?.trim();
      let apartment = item.ApartmentName?.trim();
      if (
        !this.EntrancePlantDetail.buildings?.find(
          (b) => b.name?.trim() === building
        )
      ) {
        building = undefined;
      }
      if (
        building &&
        !this.selectApartmentsByBuilding(building).find(
          (ap) => ap.name?.trim() === apartment
        )
      ) {
        apartment = undefined;
      }
      return {
        BuildingName: building,
        ApartmentName: apartment,
        label: {
          Line1: item.label.Line1?.trim(),
          Line2: item.label.Line2?.trim(),
          Type: item.label.Type,
          Info: item.label.Info,
        },
      };
    });
  }

  limitCharsLabel(data: singleLabelApartment[]) {
    return data.map((item) => {
      const maxLengthLine = item.label.Type === LabelType.Business ? 40 : 25;
      const maxLengthInfo = 225;
      return {
        BuildingName: item.BuildingName,
        ApartmentName: item.ApartmentName,
        label: {
          Line1: item.label.Line1?.trim().substring(0, maxLengthLine),
          Line2: item.label.Line2?.trim().substring(0, maxLengthLine),
          Type: item.label.Type,
          Info: item.label.Info?.substring(0, maxLengthInfo)
        },
      };
    });
   }

  selectAll() {
    if (
      this.selectedList.length ==
      this.disabledFlattenedList.filter((el) => !el.isDisabled).length
    ) {
      this.selectedList = [];
    } else {
      this.selectedList = [];
      this.flattenedList.forEach((item) => {
        let el = this.disabledFlattenedList.find((el) => {
          return (
            el.label.Line1 === item.label.Line1 &&
            el.label.Line2 === item.label.Line2 &&
            el.BuildingName === item.BuildingName &&
            el.ApartmentName === item.ApartmentName
          );
        });
        if (el && !el.isDisabled) {
          this.selectedList.push(el);
        }
      });
    }
  }

  async handleButtonSubmitAction() {
    if (this.dialogStep === 1) {
      if (this.selectedCount > 0) {
        this.shouldShowWarningStep2 =
          this.selectedCount > this.apartmentsAlreadyCreatedCount &&
          !this.isCreationMode;
      }
      if (this.shouldShowWarningStep2) {
        this.dialogStep++;
      } else {
        this.groupSelected();
        this.$emit('grouped', this.selectedGrouped);

        this.dialogStep += 2;
      }
    } else if (this.dialogStep === 2) {
      this.groupSelected();
      this.dialogStep++;
    } else if (this.dialogStep === 3) {
      this.buildingRecap();
      this.shouldShowWarningStep4 =
        this.overwrited.length > 0 && !this.isCreationMode;
      if (this.shouldShowWarningStep4) {
        this.dialogStep++;
      } else {
        this.$emit('overwrite', this.prepareToSend());
      }
    } else {
      this.$emit('overwrite', this.prepareToSend());
    }
  }

  groupSelected() {
    this.selectedGrouped = [];
    this.selectedList.forEach((item: singleLabelApartment) => {
      let row = this.selectedGrouped.find(
        (el) =>
          el.ApartmentName == item.ApartmentName &&
          el.BuildingName == item.BuildingName
      );
      let apartmentName = item.ApartmentName;
      let buildingName = item.BuildingName;
      if (row) {
        row?.validLines?.push({
          Line1: item.label.Line1,
          Line2: item.label.Line2,
          Type: item.label.Type,
          Info: item.label.Info,
        });
      } else {
        this.selectedGrouped.push({
          ApartmentName: apartmentName,
          BuildingName: buildingName,
          validLines: [
            {
              Line1: item.label.Line1,
              Line2: item.label.Line2,
              Type: item.label.Type,
              Info: item.label.Info,
            },
          ],
        });
      }
    });
  }

  isDisabled(data: singleLabelApartment) {
    if (!this.isCallingMode) return false;
    let building = data.BuildingName;
    let apartment = data.ApartmentName;
    return this.selectedList.some((item) => {
      if (
        item.BuildingName === building &&
        item.ApartmentName === apartment &&
        item.label.Line1 !== data.label.Line1 &&
        item.label.Line2 !== data.label.Line2
      ) {
        return true;
      }
    });
  }

  handleButtonCancelAction() {
    if (this.dialogStep === 3 || this.dialogStep === 2) {
      this.dialogStep = 1;
    } else if (this.dialogStep > 3) {
      this.dialogStep--;
    } else {
      this.$emit('hide-dialog');
      this.selectedList = [];
      this.flattenedList = [];
    }
  }

  formatLabel(data: singleLabelApartment) {
    let result = '';
    if (data.label.Line1 !== undefined && data.label.Line1 !== '') {
      result += data.label.Line1 + ' ';
    }
    if (data.label.Line2 !== undefined && data.label.Line2 !== '') {
      if (result.length > 0) {
        result += ' ';
      }
      result += data.label.Line2;
    }
    return result;
  }
  buildingRecap() {
    let processed: recap[] = [];

    this.selectedGrouped.forEach((item) => {
      let building = this.EntrancePlantDetail.buildings?.find(
        (b) => b.name?.trim() === item.BuildingName
      );

      let oldLabel: label[] = [];

      const apartment = building?.apartments?.find(
        (ap) => ap.name?.trim() === item.ApartmentName
      );

      if (apartment && apartment.labels) {
        oldLabel = apartment.labels.map((label) => {
          if (label.isPrivate) {
            return {
              Line1: label.surname,
              Line2: label.name,
            };
          } else {
            return {
              Line1: label.companyName,
              Line2: undefined,
            };
          }
        });
      }

      processed.push({
        ApartmentName: item.ApartmentName!,
        BuildingName: item.BuildingName!,
        OldLabel: oldLabel,
        NewLabel: item.validLines!,
        isNew: true,
      });
    });

    this.recap = processed;
    this.overwrited = processed.filter((item) => {
      if (item.NewLabel.length === 0 || item.OldLabel.length === 0) {
        return false;
      }
      return (
        item.NewLabel.length !== item.OldLabel.length ||
        item.NewLabel.some((newLabel, index) => {
          const oldLabel = item.OldLabel[index];
          if (!oldLabel) return true;
          return (
            (newLabel.Line1 !== undefined &&
              newLabel.Line1 !== oldLabel.Line1) ||
            (newLabel.Line2 !== undefined && newLabel.Line2 !== oldLabel.Line2)
          );
        })
      );
    });
  }

  handleBuildingChange(apartment: multiLabelApartment) {
    apartment.ApartmentName = undefined;
  }

  selectApartmentsByBuilding(building: string): ApartmentDTO[] {
    let result: ApartmentDTO[] = [];
    let buildings = this.EntrancePlantDetail.buildings ?? [];
    let targetBuilding = buildings.find((b) => b.name?.trim() === building);

    if (targetBuilding) {
      result =
        (targetBuilding.apartments?.map((ap) => ({
          ...ap,
          name: ap.name?.trim(),
        })) as ApartmentDTO[]) ?? [];
    }

    //gestione creazione nuove label per appartamenti non ancora creati
    let maxCount = 0;
    let traduction = this.$t('apartment');
    targetBuilding?.apartments?.forEach((ap) => {
      if (ap.name?.startsWith(traduction)) {
        let names = ap.name?.split(' ');
        if (names?.length === 2) {
          let count = parseInt(names[1]);
          if (count > maxCount) {
            maxCount = count;
          }
        }
      }
    });
    if (!this.isCreationMode) {
      let scarto = this.selectedCount - this.apartmentsAlreadyCreatedCount;
      for (let i = maxCount; i < scarto + maxCount; i++) {
        const name = `${traduction} ${i + 1}`;
        result.push(new ApartmentDTO({ name }));
      }
    }

    return result;
  }

  isAvailable(buildingName: string, apartmentName: string, index: number) {
    const isNotAvailable = this.selectedGrouped.some(
      (item: multiLabelApartment, i: number) => {
        return (
          i !== index &&
          item.ApartmentName != 'null' &&
          item.BuildingName != 'null' &&
          item.BuildingName === buildingName &&
          item.ApartmentName === apartmentName
        );
      }
    );
    return !isNotAvailable;
  }
  prepareToSend() {
    const importLabelItems = this.recap.map((item) => {
      const building = this.EntrancePlantDetail.buildings?.find(
        (b) => b.name?.trim() === item.BuildingName
      );
      const buildingId = building?.buildingId ?? undefined;
      const labels = item.NewLabel.map(
        (label) =>
          new ApartmentLabelDTO({
            surname: label.Line1,
            name: label.Line2,
            companyName:label.Type === LabelType.Business ? label.Line1 : undefined,
            labelType: label.Type || LabelType.Private,
            information: label.Info,
          })
      );
      return new ApartmentDTO({
        buildingId: buildingId,
        name: item.ApartmentName,
        labels: labels,
      });
    });

    return new BuildingImportDto({ apartments: importLabelItems });
  }
}
